import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FiltersStoreService } from '../../services/store/filters-store/filters-store.service';

@Component({
  selector: 'app-route-filteration',
  templateUrl: './route-filteration.component.html',
  styleUrls: ['./route-filteration.component.css']
})
export class RouteFilterationComponent implements OnInit {
  services:any;
  statuses:any

  constructor(
    private filtersStoreService: FiltersStoreService,
  ) { }


  ngOnInit() {
    this.filtersStoreService.state$.subscribe((res) => {
      if (res) {
        this.statuses = res.statuses,
        this.services  = res.services
      }
    })

  }

  onSelectSpaceType(event) {
    if (event) {
      event.selected = !event.selected;
      this.filtersStoreService.setService(this.services);
    }
  }

  onSelectStatus(selectedStatus: any) {
    if (selectedStatus) {
      selectedStatus.selected = !selectedStatus.selected;
       this.filtersStoreService.setStatus(this.statuses);
    }
  }
}
